import React, { ComponentType, useEffect } from 'react';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { CircularProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useAuthToken } from './AuthTokenProvider';
import ReactGA from 'react-ga4';

interface ProtectedRouteProps {
  component: ComponentType;
  [key: string]: any;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component, ...args }) => {
  const { isAuthenticated, isLoading: auth0Loading } = useAuth0();
  const { tokenSet, isLoading: tokenLoading } = useAuthToken();

  useEffect(() => {
    // Track the page view event
    ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: document.title });
  }, []);

  if (auth0Loading || tokenLoading) {
    return <CircularProgress />;
  }

  if (!isAuthenticated || !tokenSet) {
    return <Navigate to="/login" />;
  }

  const Component = withAuthenticationRequired(component);

  return (
    <React.Suspense fallback={<CircularProgress />}>
      <Component {...args} />
    </React.Suspense>
  );
};

export default ProtectedRoute;
